<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.image')"
            :preSelectedImage="data?.image?.path"
            @selectImage="selectImage"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('TABLES.Services.descriptionAr')"
            v-model.trim="data.descAr"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('TABLES.Services.descriptionEn')"
            v-model.trim="data.descEn"
            required
          />

          <base-select-input
            col="12"
            :optionsList="services"
            :placeholder="$t('PLACEHOLDERS.service')"
            v-model.trim="data.service"
            required
          />

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.packagePrice')"
            v-model="data.price"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.servicesNumber')"
            v-model="data.servicesNumber"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.subscriptiondays')"
            v-model="data.days"
            required
          />
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
              
            ></v-switch>
          </div> -->
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreatePackage",
  
  data() {
    return {
      isWaitingRequest: false,
      services: [],
      data: {
        name_ar: "",
        name_en: "",
        descAr: "",
        descEn: "",
        servicesNumber: null,
        price: null,
        type: null,
        days: null,
        is_active: null,
        service: null,
        image: {
          path: null,
          file: null,
        

},
      },
      statusOptions: [
        { id: 1, name: this.$t("STATUS.active"), value: 1 },
        { id: 0, name: this.$t("STATUS.notActive"), value: 0 },
      ],
    };
  },
  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.price) {
        REQUEST_DATA.append("price", this.data.price);
      }
      if (this.data.servicesNumber) {
        REQUEST_DATA.append("service_number", this.data.servicesNumber);
      }
      if (this.data.days) {
        REQUEST_DATA.append("days", this.data.days);
      }
      if (this.data.price) {
        REQUEST_DATA.append("price", this.data.price);
      }
      if (this.data.image) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.descAr) {
        REQUEST_DATA.append("description[ar]", this.data.descAr);
      }
      if (this.data.descEn) {
        REQUEST_DATA.append("description[en]", this.data.descEn);
      }
      if (this.data.is_active) {
        REQUEST_DATA.append("is_active", 1);
      }
      if (this.data.service) {
        REQUEST_DATA.append("service_id", this.data.service.id);
      }

      try {
        await this.$axios({
          method: "POST",
          url: "packages",
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/packages/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getServices() {
      this.loading = true;
      let res = await this.$axios({
        method: "GET",
        url: "services",
        params: {
          page: 0,
          limit: 0,
          status: 1,
        },
      });
      this.loading = false;
      this.services = res.data.data.data;
    },
  },
  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.getServices();
    // End:: Fire Methods
  },
};
</script>
